var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-navbar',[_c('b-nav-item',{attrs:{"to":"/admin/assessments"}},[_vm._v("Assessments")]),_c('b-nav-item',{attrs:{"to":"/admin/users"}},[_vm._v("Users")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }